// Define props that disable password managers, to be added when needed
const passwordManagerDisablingProps = {
	'data-1p-ignore': true,
	'data-lpignore': true,
	'data-protonpass-ignore': true,
	'data-bwignore': true,
};

export default passwordManagerDisablingProps;
